import { useRelations } from '@hooks/useAgencyPortal'

import type { AgencyPortalModel } from '@models/types'

interface AgencySelectBoxProps {
  agencyPortal: AgencyPortalModel,
}

const AgencyPortalOption = (props: AgencySelectBoxProps) => {
  const { agencyPortal } = props

  const { agency_id, agency_title, identity_code } = agencyPortal

  const { agency } = useRelations(agencyPortal)

  return (
    <option value={identity_code}>
      {agency_title || agency?.title || `Agency #${agency_id}`} - {identity_code}
    </option>
  )
}

export default AgencyPortalOption
